module.exports = __webpack_public_path__ + "img/portrait-009.af792337.jpg";